import { deliHistory } from '@global';

export function createReturnParam(prefix = '/person-management/search') {
  const location = deliHistory.location;
  return location.search
    ? `?${new URLSearchParams({
        returnTo: `${prefix}${location.search}`,
      })}`
    : '';
}
